import React from 'react';

const Community = () => {
  return (
    <div className="bg-gradient-to-b from-blue-500 to-indigo-600 min-h-screen flex flex-col justify-center items-center p-8 text-white">
      <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-8 text-justify"> Our Community</h1>
      <p className="text-lg lg:text-xl max-w-2xl mb-8">
        Join our vibrant community of passionate individuals dedicated to driving entrepreneurship and innovation in India. Connect with like-minded entrepreneurs, investors, researchers, and educators to exchange ideas, share best practices, and collaborate on impactful initiatives. Whether you're a seasoned entrepreneur or a budding innovator, our community offers a supportive environment to network, learn, and grow together.
      </p>
    </div>
  );
};

export default Community;
